var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5865 10.2271C20.5865 9.518 20.5206 8.83619 20.3983 8.18164H10.6504V12.0498H16.2206C15.9807 13.2998 15.2515 14.3589 14.1553 15.068V17.5771H17.5003C19.4574 15.8362 20.5865 13.2725 20.5865 10.2271Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6496 20.0004C13.4441 20.0004 15.787 19.1049 17.4995 17.5777L14.1545 15.0686C13.2277 15.6686 12.0422 16.0231 10.6496 16.0231C7.95389 16.0231 5.67216 14.264 4.85826 11.9004H1.40039V14.4913C3.10345 17.7595 6.60367 20.0004 10.6496 20.0004Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85855 11.9007C4.65155 11.3007 4.53394 10.6598 4.53394 10.0007C4.53394 9.34158 4.65155 8.70067 4.85855 8.10067V5.50977H1.40068C0.699695 6.85977 0.299805 8.38704 0.299805 10.0007C0.299805 11.6143 0.699695 13.1416 1.40068 14.4916L4.85855 11.9007Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6496 3.97727C12.1692 3.97727 13.5335 4.48182 14.6062 5.47273L17.5748 2.60455C15.7823 0.990909 13.4394 0 10.6496 0C6.60367 0 3.10345 2.24091 1.40039 5.50909L4.85826 8.1C5.67216 5.73636 7.95389 3.97727 10.6496 3.97727Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.dcb41b492ae6068de7e98af791ba28a8.svg";
export { ForwardRef as ReactComponent };